import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PAGE_ENUMS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type GetClientAccessRolesDto from "./dto/get-client-access-roles.dto";

export const ClientAccessRolesDetailsEffectActions = {
  getAccessRolesDetails: `${Entities.ClientAccessRolesDetails}_getAccessRolesDetails`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.ClientAccessRolesDetails,
  initSchema,
  aliasName: DIContainerKeys.ClientAccessRolesDetailsService,
})
export class ClientAccessRolesDetailsService extends HttpService {
  @loader(Loaders.GetClientAccessRolesDetailsLoader)
  @action(DIContainerKeys.ClientAccessRolesDetailsService)
  public *getAccessRolesDetails(dto: GetClientAccessRolesDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetClientAccessRolesDetailsLoader, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetClientAccessRolesDetails),
        domain: API_DOMENS.CC_API,
        params: dto.kwargs,
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetClientAccessRolesDetailsLoader, false);
      return;
    }
    yield this.setEntityStateById(Entities.ClientAccessRolesDetails, dto.clientId, response?.roles);
    yield this.setLoaderState(Loaders.GetClientAccessRolesDetailsLoader, false);
  }
}